/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Label, Row } from 'reactstrap';
import { ADD_EDIT_CONSTANT, dynamicButtonHeading } from 'utils/constants';
import CardWithTitle from 'components/CardWithTitle';
import FormikInputField from 'components/Fields/FormikInputField';
import AddressField from 'components/AddressField';
import CallingCodeField from 'components/CallingCodeField';
import LoadingButton from 'components/common/LoadingButton';

const AddVendorForm = (props) => {
  const {
    handleSubmit,
    setFieldValue,
    values,
    type,
    drawerToggle,
    isValid,
    dirty,
    isSubmitting,
  } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="Personal Details">
        <Row>
          <Col sm={5}>
            <Field
              label="First Name"
              name="firstName"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
          <Col sm={5}>
            <Field
              label="Middle Name (Optional)"
              name="middleName"
              type="text"
              component={FormikInputField}
            />
          </Col>
          <Col sm={5}>
            <Field
              label="Last Name"
              name="lastName"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col sm={5}>
            <Field
              label="Email"
              name="email"
              type="text"
              component={FormikInputField}
              // required
              disabled
            />
          </Col>

          <Col sm={5}>
            <Row>
              <Col sm={12}>
                <Label>
                  Phone Number<span className="text-danger">*</span>
                </Label>
              </Col>
              <CallingCodeField
                id="callingCode"
                name="callingCode"
                label=""
                required
                disabled
              />
              <Col className="w-100">
                <Field
                  id="phone"
                  name="phone"
                  label=""
                  type="text"
                  component={FormikInputField}
                  disabled
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </CardWithTitle>

      <AddressField values={values} setFieldValue={setFieldValue} required />

      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={() => drawerToggle('', ADD_EDIT_CONSTANT.ADD)}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          {dynamicButtonHeading(type)}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AddVendorForm;
